var SupportOrderSummaryView, SupportV2OrderSummaryView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderSummaryView = require('./order_summary_view');

SupportV2OrderSummaryView = (function(superClass) {
  extend(SupportV2OrderSummaryView, superClass);

  function SupportV2OrderSummaryView() {
    return SupportV2OrderSummaryView.__super__.constructor.apply(this, arguments);
  }

  SupportV2OrderSummaryView.prototype.buildOrderSummaryParams = function() {
    var orderSummaryParams;
    orderSummaryParams = SupportOrderSummaryView.prototype.buildOrderSummaryParams.call(this);
    orderSummaryParams.isV2 = true;
    return orderSummaryParams;
  };

  return SupportV2OrderSummaryView;

})(SupportOrderSummaryView);

module.exports = SupportV2OrderSummaryView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC92Ml9vcmRlcl9zdW1tYXJ5X3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC92Ml9vcmRlcl9zdW1tYXJ5X3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsa0RBQUE7RUFBQTs7O0FBQUEsdUJBQUEsR0FBMEIsT0FBQSxDQUFRLHNCQUFSOztBQUVwQjs7Ozs7OztzQ0FFSix1QkFBQSxHQUF5QixTQUFBO0FBQ3ZCLFFBQUE7SUFBQSxrQkFBQSxHQUFxQix1QkFBdUIsQ0FBQSxTQUFFLENBQUEsdUJBQXVCLENBQUMsSUFBakQsQ0FBc0QsSUFBdEQ7SUFDckIsa0JBQWtCLENBQUMsSUFBbkIsR0FBMEI7V0FDMUI7RUFIdUI7Ozs7R0FGYTs7QUFPeEMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
